'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/XCircle.es.js";
const o = a.forwardRef((r, c) => /* @__PURE__ */ a.createElement(p, { ref: c, ...r, weights: a$1 }));
o.displayName = "XCircleIcon";
const s = o;
export {
  s as XCircle,
  o as XCircleIcon
};
